import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>CONSTEMS AI SOLUTIONS PVT. LTD. (“CAI”) PRIVACY POLICY</h1>

      <h2>Introduction</h2>
      <p>
        Constems-AI Solutions Private Limited, its affiliates and subsidiaries
        (“CAI” “we” or “us”) are firmly committed to respect and protect your
        privacy while using our website and while using our products and
        services ("Solutions"). Your privacy is important to us and we believe
        it is important for you to know what personal data we collect from you,
        why we collect it, how we use it and what rights of yours are entitled
        to protection as a data subject or consumer.
      </p>

      <h2>Scope of Application</h2>
      <p>
        This Privacy Notice applies to processing of personal data that is
        collected, which means information about an identifiable individual
        (“you”), that we collect through our website (“Tool” or “website”) about
        applicants or freelancers like you, current or former employees and/or
        contractors. It also describes your data protection rights, including
        your right to object to some of the processing that CAI may carry out.
      </p>

      <h2>Personal Information</h2>
      <p>
        "Personal Information", also known as personally-identifiable
        information, refers to information that can be used to identify, locate,
        or contact an individual, alone or when combined with other personal or
        identifying information. It is an information that can reasonably be
        used to identify an individual and may include name, address, email
        address, phone number, login information (such as account number,
        password), social media account information, or payment card number. The
        types of Personal Information that CAI may process depends on the
        business context and the purposes for which it was collected. It may
        include (i) contact, subscription, registration, online identifiers,
        social media and discussion forum or communications details; (ii)
        Communications (such as audio, video, text) content; (iii) Online
        behaviour and product usage information; (iv) Financial Information
        (such as bank account details or credit card information); (v) Details
        of an individual’s business and other interests and opinions (such as
        where information is held in a Customer Relationship Management
        database); and (vi) Information about the user of our products and
        services, including System Information such as device identifiers, and
        telemetry (such as IP or MAC address) when such data is linked or tied
        to a specific person’s device. In addition to this, if we link any other
        data with your Personal Information, we will treat that linked data as
        Personal Information.
      </p>

      <h2>Personal Information which we may collect and process</h2>
      <p>
        Generally, you can visit our website without providing any personal data
        about yourself. However, certain information such as your IP address,
        demographics, your computers’ operating system, and browser type may be
        collected in order to provide better usability, troubleshooting, site
        maintenance, and to understand which parts of the website are visited
        and how frequently. In order to provide relevant content based on your
        preferences, when you request for information on our website, we require
        you to provide us with certain Personal Information such as your name,
        email address, telephone number etc. We do not share your Personal
        Information with third parties for marketing purposes without seeking
        your prior permission. We collect Personal Information for varied
        business reasons, such as order processing, including billing and
        payment; customer relationship management and administration; creating
        and managing user accounts; provisioning websites and Solutions and
        enabling the use of certain features; analysing, personalizing,
        improving accuracy, and enhancing user experience, communications, and
        interactions; sending communications to you, including for marketing or
        customer satisfaction purposes, either directly from CAI or from our
        partners; managing communications preferences; contract performance,
        Solution delivery, and customer service; managing a job application;
        administering online education, testing, and certifications;
        facilitating conferences, webinars, and other events; and protecting
        CAI, our users, Solutions, and others. In some instances, CAI may
        automatically collect data through cookies (a cookie is a piece of
        information that our webserver sends to your computer (actually to your
        browser file) when you access a website) and other similar applications.
      </p>

      <h2>Your Privacy Rights and Choices</h2>
      <p>
        You have the right to seek copy of your personal data from us; to
        correct, amend, delete or restrict processing of your persona data and
        to obtain the personal data you provide in a structured and
        machine-readable format. In addition to this, you have a right to object
        to the processing of personal data, in some circumstances (in
        particular, where we do not have to process the data to meet a
        contractual or legal demand). Where we have asked for your consent, you
        may withdraw consent at any time. If you have asked to withdraw your
        consent to CAI from processing your data, this will not affect any
        processing which has already taken place at that time. These rights may
        be limited, for instance, if fulfilling your request would involve
        revealing personal data of another person, or, if you ask us to delete
        information which we are required by law or have compelling legitimate
        interests to keep. If you have unresolved concerns, you have the right
        to complain to the data protection authority
      </p>

      <h2>Security of your Personal Information</h2>
      <p>
        We take reasonable, concrete and appropriate steps to protect the
        Personal Information entrusted upon us and treat it securely in
        accordance with this Privacy Policy and with law. CAI implements
        physical, technical, and organizational safeguards designed to protect
        your Personal Information from accidental or unlawful destruction, loss,
        alteration, and unauthorized disclosure or access. We also contractually
        require that our suppliers protect such information from accidental or
        unlawful destruction, loss, alteration, unauthorized disclosure, or
        access.
      </p>

      <h2>Retention of Personal Information</h2>
      <p>
        We will retain your personal data only for as long as is necessary. We
        maintain specific records management and retention policies and
        procedures, so that personal data are deleted after a reasonable time
        according to the following retention criteria; (i) we retain your data
        as long as we have an ongoing relationship with you (in particular, if
        you have an account with us); (ii) we will only keep the data while your
        account is active or for as long as needed to provide services to you;
        (iii) we retain your data for as long as needed in order to comply with
        our global legal and contractual obligations.
      </p>

      <h2>Contact us</h2>
      <p>
        The Data Controller for your personal data will be CAI through whom you
        are registering or applying for relevant work or employment positions.
        If you have any questions about this Privacy Policy or wish to contact
        us for any reason in relation to our personal data processing, please
        contact us at:{" "}
        <a href="mailto:info@constems-ai.com">info@constems-ai.com</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
